import { Helmet } from 'react-helmet-async'
import { Box, ResponsiveRender } from '@machobear/design-system'
import SideMenu from '@/features/Settings/SideMenu'
import PageTitle from '@/components/page-title'

const BaseLayout = ({ children, title = '' }) => {
  return (
    <>
      {!!title && (
        <>
          <Helmet>
            <title>{title}</title>
          </Helmet>
          <PageTitle>{title}</PageTitle>
        </>
      )}
      <Box display="flex" height="full">
        <ResponsiveRender above="mobile">
          <SideMenu />
        </ResponsiveRender>
        {children}
      </Box>
    </>
  )
}

export default BaseLayout
